import type { OnInit } from '@angular/core'
import { Component, DestroyRef, inject, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

import { TranslatePipe } from '@ngx-translate/core'
import { catchError, of, tap } from 'rxjs'

import type { SubscriptionDto } from '../../api/responses'
import { SubscriptionService } from '../../services/subscription/subscription.service'
import { ignoreAbortError } from '../../shared/rxjs/ignore-abort-error.operator'

@Component({
  selector: 'dhp-unpaid-subscription-banner',
  templateUrl: './unpaid-subscription-banner.component.html',
  imports: [TranslatePipe],
})
export class UnpaidSubscriptionBannerComponent implements OnInit {
  readonly showBanner = signal(false)

  unpaidSubscriptions = signal<SubscriptionDto[]>([])

  private readonly subscriptionService = inject(SubscriptionService)
  private readonly destroyRef = inject(DestroyRef)

  ngOnInit(): void {
    this.subscriptionService
      .getSubscriptions()
      .pipe(
        ignoreAbortError([] as SubscriptionDto[]),
        tap(subscriptions => {
          const unpaid = subscriptions.filter(
            sub => !sub.isPaid && sub.hasStarted
          )
          this.unpaidSubscriptions.set(unpaid)
          this.showBanner.set(unpaid.length > 0)
        }),
        catchError(() => {
          this.unpaidSubscriptions.set([])
          this.showBanner.set(false)
          return of([] as SubscriptionDto[])
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe()
  }
}
